import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ViewCell} from 'ng2-smart-table';
import {TopicActionModel} from '../../../../@models';

@Component({
  selector: 'ngx-form-list-actionplan',
  template: `
    <div *ngFor="let item of renderValue" [class.completed]="item.completed">
      <i class="ion-person"></i>&nbsp;{{item.name}}&nbsp;
      <i class="ion-information-circled"></i>&nbsp;{{item.action}}&nbsp;
      <i class="ion-calendar"></i>&nbsp;{{item.date | date:'dd. MM. yyyy'}}
    </div>
  `,
  styles: [
    '.completed { color: #aaaaaa; }',
  ],
})

export class FormListActionplanComponent implements ViewCell, OnInit {
  renderValue: TopicActionModel[];

  @Input() value: string | number;
  @Input() rowData: any;

  @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    this.renderValue = this.value as unknown as TopicActionModel[] ;
  }

}
